export function toast({ title, description, variant }) {
  const color = variant === 'destructive' ? '\x1b[31m' : '\x1b[32m';
  console.log(`${color}%s\x1b[0m`, `${title}: ${description}`);
}

export default toast;
